import { useSearchParams } from "react-router-dom";
import { IconLayoutDashboard, IconCheck } from "@tabler/icons-react";
import classes from "./talentOnboardingRedesign.module.css";
import { Logo } from "../../constants";

const STEPS = [
  { n: 1, label: "Upload\nResume" },
  { n: 2, label: "Personal\nInformation" },
  { n: 3, label: "Educational\nBackground" },
  { n: 4, label: "Skills &\nAbilities" },
  { n: 5, label: "Work History &\nExperience" },
  { n: 6, label: "Work\nCompensation" },
];

const STAGE_NAMES = {
  1: "Upload Resume",
  2: "Personal Information",
  3: "Educational Background",
  4: "Skills & Abilities",
  5: "Work History & Experience",
  6: "Work Compensation",
  7: "Profile Review",
};

const OnboardingLayout = ({ children }) => {
  const [param] = useSearchParams();
  const rawStage = +param.get("stage") || 1;
  const stage = Math.min(rawStage, 7);
  const stepperStage = Math.min(stage, 6);

  return (
    <div className={classes.page}>
      <header className={classes.topbar}>
        <div className={classes.topbarLogo}>
          <div className={classes.logoMark}>
            <Logo color="#fff" />
          </div>
        </div>
        <div className={classes.topbarRight}>
          <a href="/job-feed" className={classes.topbarLink}>
            <IconLayoutDashboard size={13} /> Talent Dashboard
          </a>
        </div>
      </header>

      <div className={classes.stepsStickyWrap}>
        <div className={classes.obShell}>
          <div className={classes.obSteps}>
            {STEPS.map((s) => {
              const done = stage > s.n || (stage === 7 && s.n <= 6);
              const active = stage === s.n;
              return (
                <div
                  key={s.n}
                  className={`${classes.obStep} ${done ? classes.done : ""} ${active ? classes.active : ""}`}
                >
                  <div className={classes.stepCircle}>{done ? <IconCheck size={16} /> : s.n}</div>
                  <div className={classes.stepLabel}>
                    {s.label.split("\n").map((line, i) => (
                      <span key={i}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          <div className={classes.msi}>
            <div className={classes.msiRow}>
              <span className={classes.msiCount}>
                Step <span>{stepperStage}</span> of 6
              </span>
              <span className={classes.msiName}>{STAGE_NAMES[stage]}</span>
            </div>
            <div className={classes.msiBar}>
              <div className={classes.msiFill} style={{ width: `${(stepperStage / 6) * 100}%` }} />
            </div>
          </div>
        </div>
      </div>

      <div className={classes.obBody}>
        <div className={classes.obShell}>
          {/* Stage 7 (Profile Review) and 8 (completion) still use the old,
              not-yet-redesigned components — they render their own chrome,
              so skip the new card wrapper rather than double-box them. */}
          {rawStage >= 7 ? children : <div className={classes.obCard}>{children}</div>}
        </div>
      </div>
    </div>
  );
};

export default OnboardingLayout;
